import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

function useBudgetExpenses() {
  const { trip_id } = useParams(); // Grab trip_id from URL
  const [expenses, setExpenses] = useState({
    attractions: [],
    transport: [],
    food: [],
    shopping: [],
    other: [],
  });

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const updateCategory = (category, newExpenses) => {
    setExpenses((prev) => ({
      ...prev,
      [category]: newExpenses,
    }));
  };

  useEffect(() => {
    const fetchExpenses = async () => {
      try {
        const res = await fetch(
          `http://localhost:5000/budget-saved/${trip_id}`
        );
        if (!res.ok) throw new Error("Failed to fetch expenses");
        const data = await res.json();

        // Group data by category
        setExpenses({
          attractions: data.filter((e) => e.category === "Attractions & Trips"),
          transport: data.filter((e) => e.category === "Transport"),
          food: data.filter((e) => e.category === "Food & Drink"),
          shopping: data.filter((e) => e.category === "Shopping"),
          other: data.filter((e) => e.category === "Other"),
        });
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchExpenses();
  }, [trip_id]);

  return { expenses, updateCategory, loading, error };
}

export default useBudgetExpenses;
